// libs
import { useState, useEffect, useCallback } from 'react';

// def
import { IInputProps, ReqElement } from './types';

type PartialInputProps = Pick<IInputProps, 'autoFocus' | 'isError' | 'value' | 'onFocus'>;
interface IUseHelperProps extends PartialInputProps {
  autoFocus: boolean;
}
const useHelper = ({ value, onFocus, isError, autoFocus }: IUseHelperProps) => {
  const [inFocus, setInFocus] = useState(autoFocus);
  const [isValid, setValid] = useState(value !== '');

  const setFocus = useCallback(
    (event: React.FocusEvent<ReqElement>) => {
      setValid(false);
      setInFocus(true);
      onFocus && onFocus(event);
    },
    [onFocus]
  );

  const setOutOfFocus = useCallback((event: React.FocusEvent<ReqElement>) => {
    const hasSomeValue = event.target.value !== '';

    setValid(hasSomeValue);
    setInFocus(false);
  }, []);

  // setting initial values
  useEffect(() => {
    if (value !== '') {
      setValid(true);
    }
  }, [value]);

  const barClassName = ['bar', isError && 'isError', inFocus && 'inFocus', isValid && 'isValid']
    .filter(Boolean)
    .join(' ');

  return { barClassName, inFocus, isValid, setFocus, setOutOfFocus };
};

export default useHelper;
